// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"1385":"77b369ec","2589":"d58c8f4e","5701":"f3a85754","6297":"37680801"}[chunkId] + ".css";
};